module.exports = __webpack_public_path__ + "media/images/sponsors/sponsor-03-583c824aa643e55812f8fbf0a36124ca.png";